const commonConfig = {
  startWithAudioMuted: true,
  disableSimulcast: false,
  prejoinPageEnabled: false,
  disableDeepLinking: true,
  doNotStoreRoom: true,
  disableInviteFunctions: true,
  // brandingDataUrl: "https://api-staging.assessprep.com/api/v1/get_branding_url"
}
const commonInterfaceConfig = {
  // APP_NAME: 'AP',
  
  filmStripOnly: false, // for students only
  // DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
  // SHOW_JITSI_WATERMARK: false,
  // SETTINGS_SECTIONS: [ 'devices', 'language', 'moderator', 'profile'],
  SHOW_CHROME_EXTENSION_BANNER: false,
  SETTINGS_SECTIONS: [ 'devices', 'guest'],
  HIDE_INVITE_MORE_HEADER: true,
  SHOW_DEEP_LINKING_IMAGE: false,
  SHOW_JITSI_WATERMARK: false,
  SHOW_BRAND_WATERMARK: false,
  SHOW_POWERED_BY: false,
  SHOW_PROMOTIONAL_CLOSE_PAGE: false,
  SHOW_WATERMARK_FOR_GUESTS: false,
  CLOSE_PAGE_GUEST_HINT: false,
  DISABLE_VIDEO_BACKGROUND: false,
  DISPLAY_WELCOME_PAGE_CONTENT: false,
  DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT: false,
  MOBILE_APP_PROMO: false,
  // JITSI_WATERMARK_LINK: 'https://app-staging.assessprep.com/static/media/logo-hor.1f39643e.png',
  GENERATE_ROOMNAMES_ON_WELCOME_PAGE: false,
  SUPPORT_URL: '',

  // TOOLBAR_BUTTONS: [
  //   'microphone', 'camera', 'closedcaptions', 'desktop', 'fodeviceselection', 'profile', 'chat', 'etherpad', 'sharedvideo', 'settings', 'raisehand', 'videoquality', 'filmstrip', 'feedback', 'stats', 'shortcuts', 'tileview', 'videobackgroundblur'
  // ],
  // TOOLBAR_BUTTONS: [
  //   'microphone', 'camera', 'closedcaptions', 'desktop', 'embedmeeting', 'fullscreen', 'fodeviceselection', 'hangup', 'profile', 'chat', 'recording', 'livestreaming', 'etherpad', 'sharedvideo', 'settings', 'raisehand', 'videoquality', 'filmstrip', 'invite', 'feedback', 'stats', 'shortcuts', 'tileview', 'videobackgroundblur', 'download', 'help', 'mute-everyone', 'security'
  // ],
}

export const studentVideoCallConfig = {
  configOverwrite: {
    ...commonConfig,
    startWithVideoMuted: false,
    remoteVideoMenu: {
      // If set to true the 'Kick out' button will be disabled.
      disableKick: true
    },
    disableRemoteMute: true,
    disableRemoteControl: true
  },
  interfaceConfigOverwrite: {
    ...commonInterfaceConfig,
    // filmStripOnly: true,
    DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
    DISABLE_RINGING: true,
    TOOLBAR_BUTTONS: [
      // 'microphone', 'camera', 'fodeviceselection', 'profile', 'settings', 'videoquality'
      // 'microphone'
      // 'microphone', 'camera', 'raisehand', 'chat'
      'microphone', 'camera'
    ],
  }
}

export const teacherVideoCallConfig = {
  configOverwrite: {
    ...commonConfig,
    startWithAudioMuted: false,
  },
  interfaceConfigOverwrite: {
    ...commonInterfaceConfig,
    SETTINGS_SECTIONS: [ 'devices', 'moderator'],
    // TOOLBAR_BUTTONS: [
    //   'microphone', 'camera', 'closedcaptions', 'desktop', 'fodeviceselection', 'profile', 'etherpad', 'settings', 'videoquality', 'videobackgroundblur'
    // ],


    TOOLBAR_BUTTONS: [
      'microphone', 'camera', 'mute-everyone', 'closedcaptions', 'fodeviceselection', 'profile', 'settings', 'videoquality', 'filmstrip', 'tileview'
      // 'chat', 'microphone', 'camera', 'mute-everyone', 'closedcaptions', 'fodeviceselection', 'profile', 'settings', 'videoquality', 'filmstrip', 'feedback', 'tileview'
      // 'microphone', 'camera', 'closedcaptions', 'desktop', 'fodeviceselection', 'profile', 'settings', 'videoquality', 'filmstrip', 'feedback', 'tileview'
    ],
    // TOOLBAR_BUTTONS: [
  //   'microphone', 'camera', 'closedcaptions', 'desktop', 'embedmeeting', 'fullscreen', 'fodeviceselection', 'hangup', 'profile', 'chat', 'recording', 'livestreaming', 'etherpad', 'sharedvideo', 'settings', 'raisehand', 'videoquality', 'filmstrip', 'invite', 'feedback', 'stats', 'shortcuts', 'tileview', 'videobackgroundblur', 'download', 'help', 'mute-everyone', 'security'
  // ],
  }
}